import { render } from "./CurrentFootballMatch.vue?vue&type=template&id=29954ca2&scoped=true"
import script from "./CurrentFootballMatch.vue?vue&type=script&lang=js"
export * from "./CurrentFootballMatch.vue?vue&type=script&lang=js"

import "./CurrentFootballMatch.vue?vue&type=style&index=0&id=29954ca2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-29954ca2"

export default script